/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VlsrPersonaEnum } from './vlsrPersonaEnum';


export interface RecordDisconnectedUsagePostSpec { 
    /**
     * Disconnected SRM pair UUID
     */
    entity_uuid: string;
    org_id: string;
    quantity: number;
    persona: VlsrPersonaEnum;
    expiry_ts: Date;
}
export namespace RecordDisconnectedUsagePostSpec {
}


